export default {
    QUEBRA: 1,
    FALTA_DE_ENERGIA: 2,
    FALHA_DE_EQUIPAMENTO: 3,
    VALIDADE_VENCIDA: 4,
    PROCEDIMENTO_INADEQUADO: 5,
    OUTROS: 6,
    PERDA_NO_TRANSPORTE: 7,
    USO_EM_APLICAÇÃO: 8,
}